import React from 'react';
import PropTypes from 'prop-types';

// styles
import * as S from './styles';

const Avatar = ({ name, imageUrl }) => {
  return (
    <S.Avatar data-testid="avatar">
      {imageUrl ? <img data-testid="avatar-image" src={imageUrl} alt={name} /> : name && name[0]}
    </S.Avatar>
  );
};

Avatar.propTypes = {
  name: PropTypes.string,
  imageUrl: PropTypes.string
};

export default Avatar;